"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DraftDiff = exports.GraphQLConfigDiff = exports.SchemaOptionsDiff = exports.FieldDiff = exports.AppDependenciesDiff = exports.DependencyDiffData = exports.DependencyData = exports.AppAssetDiff = exports.PartialDraft = void 0;
var App_1 = require("./App");
var json2typescript_1 = require("json2typescript");
var PartialDraft = (function () {
    function PartialDraft(partial) {
        this.id = '';
        this.userId = '';
        this.app = new App_1.PartialApp();
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('_id', String),
        __metadata("design:type", Object)
    ], PartialDraft.prototype, "id", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('user_id', String),
        __metadata("design:type", Object)
    ], PartialDraft.prototype, "userId", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('app', App_1.PartialApp),
        __metadata("design:type", App_1.PartialApp)
    ], PartialDraft.prototype, "app", void 0);
    PartialDraft = __decorate([
        (0, json2typescript_1.JsonObject)('PartialDraft'),
        __metadata("design:paramtypes", [Object])
    ], PartialDraft);
    return PartialDraft;
}());
exports.PartialDraft = PartialDraft;
var AppAssetDiff = (function () {
    function AppAssetDiff(partial) {
        this.added = [];
        this.deleted = [];
        this.modified = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('added', [String]),
        __metadata("design:type", Array)
    ], AppAssetDiff.prototype, "added", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('deleted', [String]),
        __metadata("design:type", Array)
    ], AppAssetDiff.prototype, "deleted", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('modified', [String]),
        __metadata("design:type", Array)
    ], AppAssetDiff.prototype, "modified", void 0);
    AppAssetDiff = __decorate([
        (0, json2typescript_1.JsonObject)('AppAssetDiff'),
        __metadata("design:paramtypes", [Object])
    ], AppAssetDiff);
    return AppAssetDiff;
}());
exports.AppAssetDiff = AppAssetDiff;
var DependencyData = (function () {
    function DependencyData(partial) {
        this.name = '';
        this.version = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], DependencyData.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('version'),
        __metadata("design:type", Object)
    ], DependencyData.prototype, "version", void 0);
    DependencyData = __decorate([
        (0, json2typescript_1.JsonObject)('DependencyData'),
        __metadata("design:paramtypes", [Object])
    ], DependencyData);
    return DependencyData;
}());
exports.DependencyData = DependencyData;
var DependencyDiffData = (function () {
    function DependencyDiffData(partial) {
        this.name = '';
        this.version = '';
        this.previousVersion = '';
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('name'),
        __metadata("design:type", Object)
    ], DependencyDiffData.prototype, "name", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('version'),
        __metadata("design:type", Object)
    ], DependencyDiffData.prototype, "version", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('previous_version'),
        __metadata("design:type", Object)
    ], DependencyDiffData.prototype, "previousVersion", void 0);
    DependencyDiffData = __decorate([
        (0, json2typescript_1.JsonObject)('DependencyDiffData'),
        __metadata("design:paramtypes", [Object])
    ], DependencyDiffData);
    return DependencyDiffData;
}());
exports.DependencyDiffData = DependencyDiffData;
var AppDependenciesDiff = (function () {
    function AppDependenciesDiff(partial) {
        this.added = [];
        this.deleted = [];
        this.modified = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('added', [DependencyData]),
        __metadata("design:type", Array)
    ], AppDependenciesDiff.prototype, "added", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('deleted', [DependencyData]),
        __metadata("design:type", Array)
    ], AppDependenciesDiff.prototype, "deleted", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('modified', [DependencyData]),
        __metadata("design:type", Array)
    ], AppDependenciesDiff.prototype, "modified", void 0);
    AppDependenciesDiff = __decorate([
        (0, json2typescript_1.JsonObject)('AppDependenciesDiff'),
        __metadata("design:paramtypes", [Object])
    ], AppDependenciesDiff);
    return AppDependenciesDiff;
}());
exports.AppDependenciesDiff = AppDependenciesDiff;
var FieldDiff = (function () {
    function FieldDiff(partial) {
        this.field = '';
        this.previousValue = undefined;
        this.updatedValue = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('field_name', String),
        __metadata("design:type", Object)
    ], FieldDiff.prototype, "field", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('previous'),
        __metadata("design:type", Object)
    ], FieldDiff.prototype, "previousValue", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('updated'),
        __metadata("design:type", Object)
    ], FieldDiff.prototype, "updatedValue", void 0);
    FieldDiff = __decorate([
        (0, json2typescript_1.JsonObject)('FieldDiff'),
        __metadata("design:paramtypes", [Object])
    ], FieldDiff);
    return FieldDiff;
}());
exports.FieldDiff = FieldDiff;
var SchemaOptionsDiff = (function () {
    function SchemaOptionsDiff(partial) {
        this.graphQLValidationDiffs = [];
        this.restValidationDiffs = [];
        this.nullTypeSchemaValidationDiff = undefined;
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('graphql_validation_diff', [FieldDiff]),
        __metadata("design:type", Array)
    ], SchemaOptionsDiff.prototype, "graphQLValidationDiffs", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('rest_validation_diff', [FieldDiff]),
        __metadata("design:type", Array)
    ], SchemaOptionsDiff.prototype, "restValidationDiffs", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('null_type_schema_validation_diff', FieldDiff),
        __metadata("design:type", FieldDiff)
    ], SchemaOptionsDiff.prototype, "nullTypeSchemaValidationDiff", void 0);
    SchemaOptionsDiff = __decorate([
        (0, json2typescript_1.JsonObject)('SchemaOptionsDiff'),
        __metadata("design:paramtypes", [Object])
    ], SchemaOptionsDiff);
    return SchemaOptionsDiff;
}());
exports.SchemaOptionsDiff = SchemaOptionsDiff;
var GraphQLConfigDiff = (function () {
    function GraphQLConfigDiff(partial) {
        this.fieldDiffs = [];
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('field_diffs', [FieldDiff]),
        __metadata("design:type", Array)
    ], GraphQLConfigDiff.prototype, "fieldDiffs", void 0);
    GraphQLConfigDiff = __decorate([
        (0, json2typescript_1.JsonObject)('GraphQLConfigDiff'),
        __metadata("design:paramtypes", [Object])
    ], GraphQLConfigDiff);
    return GraphQLConfigDiff;
}());
exports.GraphQLConfigDiff = GraphQLConfigDiff;
var DraftDiff = (function () {
    function DraftDiff(partial) {
        this.diffs = [];
        this.hostingFilesDiff = new AppAssetDiff();
        this.dependenciesDiff = new AppDependenciesDiff();
        this.graphQLConfigDiff = new GraphQLConfigDiff();
        this.schemaOptionsDiff = new SchemaOptionsDiff();
        Object.assign(this, partial);
    }
    __decorate([
        (0, json2typescript_1.JsonProperty)('diffs', [String]),
        __metadata("design:type", Array)
    ], DraftDiff.prototype, "diffs", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('hosting_files_diff', AppAssetDiff),
        __metadata("design:type", AppAssetDiff)
    ], DraftDiff.prototype, "hostingFilesDiff", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('dependencies_diff', AppDependenciesDiff),
        __metadata("design:type", AppDependenciesDiff)
    ], DraftDiff.prototype, "dependenciesDiff", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('graphql_config_diff', GraphQLConfigDiff),
        __metadata("design:type", GraphQLConfigDiff)
    ], DraftDiff.prototype, "graphQLConfigDiff", void 0);
    __decorate([
        (0, json2typescript_1.JsonProperty)('schema_options_diff', SchemaOptionsDiff),
        __metadata("design:type", SchemaOptionsDiff)
    ], DraftDiff.prototype, "schemaOptionsDiff", void 0);
    DraftDiff = __decorate([
        (0, json2typescript_1.JsonObject)('DraftDiff'),
        __metadata("design:paramtypes", [Object])
    ], DraftDiff);
    return DraftDiff;
}());
exports.DraftDiff = DraftDiff;
//# sourceMappingURL=Draft.js.map